// Libarary
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// View Model
import { AccountVM } from '../../models/AccountMasterVM';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { BroadcastService } from '../infrastructure/broadcaster.service';
import { NetworkService } from '../infrastructure/network.service';
import { MasterConstants } from '../../common/constants/master-constants';
import { ReturnPeriodSecurityList } from '../../models/SeedReturn/ReturnPeriodSecurityList';
import { LoaderService } from '../infrastructure/loader.service';
import pdfMake from 'pdfmake/build/pdfmake';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../common/common.service';
import { DatePipe } from '@angular/common';

@Injectable()
export class SeedReturnService {
  public SelectedAccountObj: BehaviorSubject<AccountVM>;
  public isAccountSelectedOnLP = false;
  public isGrowerSelectedOnLP = false;
  public SelectedGwrOrderId: BehaviorSubject<string>;
  public SelectedProductLineId: BehaviorSubject<string>;
  public selectedAccountNo: any;
  public selectedAccountParentNo: any;
  public isEditMode = false;
  public productList: any = [];
  public redirectFrom: any;
  public returnRequestStatus: string;
  public dashboardSelectedProductLine = 'All';
  public isExceptionPeriod = false;
  public isNewSeedReturnAllowed = false;
  public returnPeriodSecurityList: ReturnPeriodSecurityList[];
  pdfDataObject: any;
  shipToAccountDetails: any = {};
  isReturnTypeForInnoculant: boolean = false;
  shouldShowSurveyMessage: boolean;
  evolveSurveyUrl: string;

  constructor(public broadcastService: BroadcastService,
    public configService: ConfigService,
    private networkService: NetworkService, public loaderService: LoaderService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private datePipe: DatePipe) {
    this.SelectedAccountObj = new BehaviorSubject<AccountVM>(null);
    this.SelectedGwrOrderId = new BehaviorSubject<string>('0');
    this.SelectedProductLineId = new BehaviorSubject<string>('');
    this.seedReturnOrderId = new BehaviorSubject(0);
    this.returnRequestId = new BehaviorSubject(0);
  }
  webOrderNumberAndSplitId: any;
  seedReturnOrderId: BehaviorSubject<number>;
  returnRequestId: BehaviorSubject<number>;

  public setSeedReturnOrderId(value: number) {
    this.seedReturnOrderId.next(value);
  }

  public setSelectedProductLine(value: string) {
    const val = MasterConstants.PRODUCT_LINE_LIST.filter(x => x.Value.toUpperCase() == value.toUpperCase());
    value = val && val.length > 0 ? val[0].Id : '';
    this.SelectedProductLineId.next(value);
  }

  public getProductLineTextById(value: string) {
    const val = MasterConstants.PRODUCT_LINE_LIST.filter(x => x.Id.toUpperCase() == value.toUpperCase());
    value = val && val.length > 0 ? val[0].Text : '';
    return value;
  }

  public getProductLineTextByValue(value: string) {
    const val = MasterConstants.PRODUCT_LINE_LIST.filter(x => x.Value.toUpperCase() == value.toUpperCase());
    value = val && val.length > 0 ? val[0].Text : '';
    return value;
  }

  public getProductLineValueById(value: string) {
    const val = MasterConstants.PRODUCT_LINE_LIST.filter(x => x.Id.toUpperCase() == value.toUpperCase());
    value = val && val.length > 0 ? val[0].Value : '';
    return value;
  }

  public getProductLineIdByValue(value: string): string {
    const val = MasterConstants.PRODUCT_LINE_LIST.filter(x => x.Value.toUpperCase() == value.toUpperCase());
    value = val && val.length > 0 ? val[0].Id : '';
    return value;
  }

  public getProductLineImageById(value: string) {
    const val = MasterConstants.PRODUCT_LINE_LIST.filter(x => x.Id.toUpperCase() == value.toUpperCase());
    value = val && val.length > 0 ? val[0].Image : '';
    return value;
  }

  public setReturnRequestId(value: number) {
    this.returnRequestId.next(value);
  }
  public setReturnRequestStatus(value: string) {
    this.returnRequestStatus = value;
  }

  public setIsReturnTypeForInoculant(value: boolean) {
    this.isReturnTypeForInnoculant = value;
  }
  public setRedirectionFrom(value) {
    this.redirectFrom = value;
  }

  getSelectedAccountNo() {
    return this.selectedAccountNo;
  }

  setSelectedAccountNo(selectedAccountNo) {
    this.selectedAccountNo = selectedAccountNo;
  }

  getSelectedParentAccountNo() {
    return this.selectedAccountParentNo;
  }

  setSelectedParentAccountNo(selectedAccountParentNo) {
    this.selectedAccountParentNo = selectedAccountParentNo;
  }

  getEditModeStatus() {
    return this.isEditMode;
  }

  setEditModeStatus(isEditMode) {
    this.isEditMode = isEditMode;
  }
  getProductList() {
    return this.productList;
  }

  setProductList(productList) {
    this.productList = productList;
  }
  public AccountChange(obj: AccountVM) {
    this.SelectedAccountObj.next(obj);
  }
  // Get Item Number List
  public getItemNumberList() {
    return this.networkService.getRequest(this.configService.getSeedReturnItemNumberData());
  }
  // Get Account detail data for Account dropdown
  public getAccountList() {
    return this.networkService.getRequest(this.configService.getSeedReturnAccountListUrl());
  }

  // Get Freight Instruction data for Freight Instruction dropdown
  public getFreightList() {
    return this.networkService.getRequest(this.configService.getSeedReturnFreightInstUrl());
  }

  // Get Cpp Order Items List
  public getReturnRequestList(filters) {
    return this.networkService.postRequest(this.configService.getreturnRequestData(), filters);
  }

  // Get Seed Return Export List
  public getReturnRequestExportList(filters) {
    return this.networkService.postRequest(this.configService.getreturnRequestExportData(), filters);
  }

  // Get DSM info
  public getDSMInfo(accountNo, cropYear) {
    return this.networkService.getRequest(this.configService.getDSMData() + '?accountNumber=' + accountNo + '&cropYear=' + cropYear);
  }

  // Get lot number list
  public getInvoiceNumberList(accountNo) {
    return this.networkService.getRequest(this.configService.getInvoiceNumberList() + '?accountNumber=' + accountNo);
  }
  // Get invoiced product list for grid
  public getInvoicedProductItems(filters) {
    return this.networkService.postRequest(this.configService.getInvoicedProductItems(), filters);
  }

  // Get lot master list
  public getLotMasterList(accountNumber) {
    return this.networkService.getRequest(this.configService.getLotMasterItems() + '?accountNumber=' + accountNumber);
  }


  public submitReturnRequest(data) {
    return this.networkService.postRequest(this.configService.saveReturnRequests(), data);
  }

  public submitScaleTickets(data) {
    return this.networkService.postRequest(this.configService.saveScaleTickets(), data);
  }

  public submitToJDEReturnRequest(data) {
    return this.networkService.postRequest(this.configService.submitToJDEReturnRequests(), data);
  }

  public getScaleTicketFile(scaleTicketId) {
    return this.networkService.getRequest(this.configService.getScaleTicketFile() + '?scaleTicketId=' + scaleTicketId);
  }

  // Get Edit request detail
  public getEditRequestDetail(requestId, returnRequestNumber = null) {
    return this.networkService.getRequest(this.configService.getReturnRequestEditDetailData() + '?requestId=' + requestId + '&returnRequestNumber=' + returnRequestNumber);
  }

  // Get products by lot number
  public deleteScaleTicket(data) {
    return this.networkService.postRequest(this.configService.deleteScaleTicket(), data);
  }

  // Delete Order
  public deleteRequest(returnRequestId) {
    return this.networkService.postRequest(this.configService.deleteReturnRequest(), returnRequestId);
  }

  // Get account user
  public getAccountUser(accountNumber) {
    return this.networkService.getRequest(this.configService.getAccountUser() + '?accountNumber=' + accountNumber);
  }

  // Get scale ticket file extensions
  public getScaleTicketFileExtensions() {
    return this.networkService.getRequest(this.configService.getScaleTicketFileExtensions());
  }

  // Get Banner Message url
  public getBannerMessage(productLineId) {
    return this.networkService.getRequest(this.configService.GetBannerMessageUrl() + '?productLineId=' + productLineId);
  }

  // Get Deliver To Facility List
  public getDeliverToFacilityList(accountNumber, shipToAccountParentNumber) {
    const url = this.configService.getAPIPath(this.configService.getSeedReturnDeliverToFacilityDataUrl,
      { accountNumber: accountNumber, shipToAccountParentNumber: shipToAccountParentNumber });
    return this.networkService.getRequest(url);
  }

  public getReturnMaster(productLine) {
    const url = this.configService.getAPIPath(this.configService.getSeedReturnReturnMasterDataUrl,
      { productLine: productLine });
    return this.networkService.getRequest(url);
  }

  // Get produt line list
  public getProductLineList() {
    return this.networkService.getRequest(this.configService.getProductLine());
  }

  // check OTI Orders Exist for Customer PO
  public checkOTIOrders(shipToAccount, customerPO) {
    return this.networkService.getRequest(this.configService.checkOTIOrdersForPOUrl() + '?shipToAccount=' + shipToAccount + '&customerPO=' + customerPO);
  }

  // Get return request header id by inputs value for draft
  public getDraftReturnRequest(accountNumber, productLineCode) {
    const url = this.configService.getAPIPath(this.configService.getDraftReturnRequestDataUrl,
      { accountNumber: accountNumber, productLineCode: productLineCode });
    return this.networkService.getRequest(url);
  }

  public getReturnPeriodSecurity() {
    return this.networkService.getRequest(this.configService.getReturnPeriodSecurityDataUrl);
  }

  public getAccountDetailsforZeroDump(accountNumber, isLinkedAccountSelected) {
    return this.networkService.getRequest(this.configService.getAccountdetails + '?accountNumber=' + accountNumber + '&isLinkedAccountSelected=' + isLinkedAccountSelected);
  }

  public saveNonSoybeanZeroDump(data) {
    return this.networkService.postRequest(this.configService.saveSoybeanNoDumps(), data);
  }

  public setReturnPeriodSecurityList(list) {
    this.returnPeriodSecurityList = list;
  }

  public updateReturnRequestHeader(seedReturnCreateVM) {
    return this.networkService.postRequest(this.configService.UpdateReturnRequestStatus(), seedReturnCreateVM);
  }

  public getMiscellaneousItemComputationData(productLineID) {
    return this.networkService.getRequest(this.configService.GetMiscellaneousItemComputationDataUrl + '?productLineID=' + productLineID);
  }

  //Get Process Access for non soybean
  public getProcessAccessForNonSoybean(productLineID, shipToAccount = null) {
    let url = this.configService.getProcessAccessForNonSoybean() + '?productLineID=' + productLineID;
    if (shipToAccount) {
      url += '&shipToAccount=' + shipToAccount;
    }
    return this.networkService.getRequest(url);
  }

  // Get Return Period Validation Status for selected Ship-To account (AC5)
  public getReturnPeriodValidationStatus(productLineID, shipToAccount) {
    return this.networkService.getRequest(this.configService.getReturnPeriodValidation() + '?productLineID=' + productLineID + '&shipToAccount=' + shipToAccount);
  }

  public generatePdf(RequestHeaderId, ReturnRequestNumber = null) {
    if (RequestHeaderId || ReturnRequestNumber) {
      this.loaderService.setLoaderStatus(true);
      this.getEditRequestDetail(RequestHeaderId, ReturnRequestNumber).subscribe((result) => {
        if (result) {
          this.pdfDataObject = result;
          const documentDefinition = this.getDocumentDefinition(RequestHeaderId, ReturnRequestNumber);
          const Product = this.getProductLineTextById(this.pdfDataObject.productLine);
          pdfMake.createPdf(documentDefinition).download('Seed Return-' + Product + '-' + result.returnRequestNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
        }
        else {
          this.toastrService.error('No data available for RequestNumber #' + result.returnRequestNumber);
        }
        this.loaderService.setLoaderStatus(false);
      }, error => {
        this.loaderService.setLoaderStatus(false);
      });
    }
  }

  getDocumentDefinition(requestHeaderId, returnRequestNumber) {
    const orderCreateDate = this.datePipe.transform(this.pdfDataObject.createTimestamp, 'MMMM dd, yyyy');
    const createDateTime = this.pdfDataObject.createdOnString;
    this.shipToAccountDetails = {};
    const Product = this.getProductLineTextById(this.pdfDataObject.productLine);
    if (this.pdfDataObject.shipToAccountDetail) {
      this.shipToAccountDetails.AccountNumber = this.pdfDataObject.shipToAccountDetail.accountNumber;
      this.shipToAccountDetails.AccountName = this.pdfDataObject.shipToAccountDetail.accountName;
      this.shipToAccountDetails.Address1 = this.pdfDataObject.shipToAccountDetail.address1;
      this.shipToAccountDetails.Address2 = this.pdfDataObject.shipToAccountDetail.Address2;
      this.shipToAccountDetails.AccountCity = this.pdfDataObject.shipToAccountDetail.city;
      this.shipToAccountDetails.AccountState = this.pdfDataObject.shipToAccountDetail.state;
      this.shipToAccountDetails.AccountZipCode = this.pdfDataObject.shipToAccountDetail.zipCode;
    }

    let displayWith = [];
    let columnList = [];
    let valueList = [];

    // ShipTo Account available
    if (this.shipToAccountDetails.AccountName) {
      displayWith = ['100%'];
      columnList = [{ text: '', bold: true, }];
      valueList = [
        'Account #: ' + this.shipToAccountDetails.AccountNumber + ' \n' +
        'Seed Return: ' + Product + ' ' + this.pdfDataObject.returnRequestNumber + ' \n' +
        this.shipToAccountDetails.AccountName + ' \n' +
        this.shipToAccountDetails.Address1 + ' \n' +
        this.shipToAccountDetails.AccountCity + ', ' + this.shipToAccountDetails.AccountState + ' ' + this.shipToAccountDetails.AccountZipCode + ' \n'
      ];
    }
    let displayWithPickupInfo = [];
    let valueListPickupInfoRight = [];
    let valueListPickupInfoLeft = [];
    // pickup Info available
    if (this.pdfDataObject.pickupInfo) {
      displayWithPickupInfo = ['50%', '50%'];
      if (this.pdfDataObject.pickupInfo.shippingInstructions == null) {
        this.pdfDataObject.pickupInfo.shippingInstructions = ' ';
      }
      if (this.pdfDataObject.pickupInfo.emptyPalletCount == null) {
        this.pdfDataObject.pickupInfo.emptyPalletCount = ' ';
      }
      if (this.pdfDataObject.pickupInfo.palletCount == null) {
        this.pdfDataObject.pickupInfo.palletCount = ' ';
      }
      if (this.pdfDataObject.pickupInfo.emptyCboxCount == null) {
        this.pdfDataObject.pickupInfo.emptyCboxCount = ' ';
      }

      if (requestHeaderId && !returnRequestNumber) {
        valueListPickupInfoLeft = [
          'Desired Pickup Date: ' + this.datePipe.transform(this.pdfDataObject.pickupInfo.requestDate.replace('T', ' '), MasterConstants.DATE_MMDDYYYY) + ' \n' +
          'Contact Name: ' + this.pdfDataObject.pickupInfo.contactName + ' \n' +
          'Contact Number: ' + this.pdfDataObject.pickupInfo.contactNumber + ' \n' +
          'Customer PO Number: ' + this.pdfDataObject.pickupInfo.custPONumber + ' \n' +
          'Pickup Location: ' + this.pdfDataObject.pickupInfo.pickUpLocationName + ' \n'
        ];
        valueListPickupInfoRight = [
          'Shipping Instructions: ' + this.pdfDataObject.pickupInfo.shippingInstructions + ' \n' +
          'Freight Instructions: ' + this.pdfDataObject.pickupInfo.freightInstructionsDescription + ' \n' +
          'Pallet Count: ' + this.pdfDataObject.pickupInfo.palletCount + ' \n' +
          'Empty Pallet Count:' + this.pdfDataObject.pickupInfo.emptyPalletCount + ' \n' +
          'Empty CBox Count:' + this.pdfDataObject.pickupInfo.emptyCboxCount + ' \n'
        ];
      }
      else {
        valueListPickupInfoLeft = [
          'Desired Pickup Date: ' + this.datePipe.transform(this.pdfDataObject.pickupInfo.requestDate.replace('T', ' '), MasterConstants.DATE_MMDDYYYY) + ' \n' +
          'Contact Name: ' + this.pdfDataObject.pickupInfo.contactName + ' \n' +
          'Contact Number: ' + this.pdfDataObject.pickupInfo.contactNumber + ' \n' +
          'Customer PO Number: ' + this.pdfDataObject.pickupInfo.custPONumber + ' \n'
        ];
        valueListPickupInfoRight = [
          'Pickup Location: ' + this.pdfDataObject.pickupInfo.pickUpLocationName + ' \n' +
          'Shipping Instructions: ' + this.pdfDataObject.pickupInfo.shippingInstructions + ' \n' +
          'Freight Instructions: ' + this.pdfDataObject.pickupInfo.freightInstructionsDescription + ' \n'
        ];
      }
    }

    if (Product == 'Grain Sorghum') {
      if (requestHeaderId && !returnRequestNumber) {
        valueListPickupInfoRight = [
          'Shipping Instructions: ' + this.pdfDataObject.pickupInfo.shippingInstructions + ' \n' +
          'Freight Instructions: ' + this.pdfDataObject.pickupInfo.freightInstructionsDescription + ' \n' +
          'Pallet Count: ' + this.pdfDataObject.pickupInfo.palletCount + ' \n' +
          'Empty Pallet Count:' + this.pdfDataObject.pickupInfo.emptyPalletCount + ' \n'
        ];
      }
      else {
        valueListPickupInfoRight = [
          'Pickup Location: ' + this.pdfDataObject.pickupInfo.pickUpLocationName + ' \n' +
          'Shipping Instructions: ' + this.pdfDataObject.pickupInfo.shippingInstructions + ' \n' +
          'Freight Instructions: ' + this.pdfDataObject.pickupInfo.freightInstructionsDescription + ' \n'
        ];
      }
    }
    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: orderCreateDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          style: 'pageText',
          widths: ['25%', '50%', '25%'],
          marginTop: 10,
          fontSize: 8,
          bold: true,
          columns: [{
            image: 'data:image/png;base64,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',
            width: 60,
            height: 20,
            alignment: 'left',
            fit: [100, 100]
          }]
        },
        {
          text: 'Copyright 2019 - WinField United, a property of Land O\'Lakes, Inc.All Right Reserved.',
          fontSize: 8,
          style: 'pageText',
          marginTop: 5
        },
        {
          style: 'headername',
          table: {
            body: [
              [
                'Seed Return-' + Product + ' ' + this.pdfDataObject.returnRequestNumber
              ],
            ]
          },
          fontSize: 18,
          layout: 'noBorders',
          marginTop: 15
        },
        {
          layout: 'noBorders',
          table: {
            body: [
              ['']
            ]
          },
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          text: [
            'A ' + 'Seed Return -' + Product + ' ' + ' has been submitted for ',
            { text: this.shipToAccountDetails.AccountName, bold: true },
            '. Please review the receipt below to ensure the request is correct. Reference number ' + this.pdfDataObject.returnRequestNumber + ' in all communications.',
          ],
          style: 'pageText',
          fontSize: 9,
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            fontSize: 5,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'tableHeader',
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 2 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#d7dcee' : '#F5F6FA';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#d7dcee' : '#d7dcee';
            },
          }
        },
        {
          text: [{ text: 'Pickup Information', bold: true }],
          style: 'pageText',
          fontSize: 10,
          marginTop: 10,
        },
        {
          table: {
            widths: displayWithPickupInfo,
            fontSize: 5,
            body: [
              [{
                text: '',
                style: 'tableHeader', marginTop: 0,
              },
              {
                text: '',
                style: 'tableHeader', marginTop: 0,
              }],
              [
                valueListPickupInfoLeft,
                valueListPickupInfoRight,
              ]]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'tableHeader',
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 2 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#d7dcee' : '#F5F6FA';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#d7dcee' : '#d7dcee';
            },
          }
        },
        (requestHeaderId && !returnRequestNumber ? this.getContractPdfObject(this.pdfDataObject) : this.getSplitProductPdfObject(this.pdfDataObject)),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis Seed Return-' + Product + ' ' + 'Request was submitted by ' + this.pdfDataObject.requestedBy
                + '. Note that requested units could be subject to change. If you have questions regarding this request, please contact Winfield United Customer Service #855-494-6343.'],
            ]
          },
          layout: 'noBorders',
          marginTop: 20
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        headername: {
          fontSize: 18,
          bold: true,
          color: '#0b3f54'
        },
        tableHeader: {
          bold: true,
          fillColor: '#F5F6FA',
          fontSize: 8,
          color: '#0b3f54',
          border: [true, true, true, true],
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
      }
    };

    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(pdfDataObject) {
    const tblObject = [];
    const seedReturnProductList = pdfDataObject.seedReturnProductList;
    const tblFailed = {
      layout: 'noBorders',
      table: {
        widths: ['20%', '15%', '15%', '15%', '15%', '10%', '10%'],
        color: '#0b3f54',
        body: [
          [{
            text: 'Product',
            style: 'tableHeader', marginTop: 5,
          },
          {
            text: 'Item Number',
            style: 'tableHeader', alignment: 'center'
          },
          {
            text: 'Lot Number',
            style: 'tableHeader', alignment: 'center'
          },
          {
            text: 'UOM',
            style: 'tableHeader', alignment: 'center'
          },
          {
            text: 'Eligible Units',
            style: 'tableHeader', alignment: 'center'
          },
          {
            text: 'Requested Units',
            style: 'tableHeader', alignment: 'center'
          },
          {
            text: 'Customer Notes',
            style: 'tableHeader', alignment: 'center'
          },
          ],
          ...seedReturnProductList.map(cl => [
            { text: cl.itemDescription },
            { text: cl.itemId, alignment: 'center' },
            { text: cl.lotNumber, alignment: 'center' },
            { text: cl.uom, alignment: 'center' },
            { text: cl.eligibleUnit, alignment: 'center' },
            { text: cl.returnQuantity, alignment: 'center' },
            { text: cl.requestorNotes, alignment: 'center' },
          ])
        ]
      },
      style: 'tablefont',
      marginTop: 10,
    };
    tblObject.push(tblFailed);
    return tblObject;
  }
  getSplitProductPdfObject(pdfDataObject) {
    const tblObject = [];
    const splitDetails = pdfDataObject.splitDetails;
    splitDetails.map(data => {
      const tblPalletAndCbox = {
        layout: 'noBorders',
        table: {
          widths: ['45%', '15%', '20%', '20%'],
          body: [
            [{
              text: 'Request ID: ' + data.returnRequestNumber + '-' + data.splitId,
              alignment: 'left', bold: true, fontSize: 9
            },
            {
              text: 'Pallet Count: ' + data.splitStockPalletCount,
              alignment: 'left', bold: true, fontSize: 9
            },
            {
              text: 'Empty Pallet Count: ' + data.splitEmptyStockPalletCount,
              alignment: 'left', bold: true, fontSize: 9
            },
            {
              text: 'Empty CBox Count: ' + data.splitEmptyCboxCount,
              alignment: 'left', bold: true, fontSize: 9
            }
            ]
          ]
        },
        style: 'tablefont',
        marginTop: 10,
      };

      tblObject.push(tblPalletAndCbox);

      if (data.productDetail && data.productDetail.length > 0) {
        const tblProductDetails = {
          layout: 'noBorders',
          table: {
            widths: ['45%', '30%', '25%'],
            color: '#0b3f54',
            body: [
              [{
                text: 'Product',
                style: 'tableHeader'
              },
              {
                text: 'Lot #',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Units',
                style: 'tableHeader', alignment: 'center'
              }
              ],
              ...data.productDetail.map(cl => [
                { text: cl.itemDescription },
                { text: cl.lotNumber, alignment: 'center' },
                { text: cl.returnQuantity, alignment: 'center' }
              ])
            ]
          },
          style: 'tablefont',
          marginTop: 5,
        };

        tblObject.push(tblProductDetails);
      }
      else {
        const tblProductDetails = {
          layout: 'noBorders',
          table: {
            widths: ['45%', '30%', '25%'],
            color: '#0b3f54',
            body: [
              [{
                text: 'Product',
                style: 'tableHeader'
              },
              {
                text: 'Lot #',
                style: 'tableHeader', alignment: 'center'
              },
              {
                text: 'Units',
                style: 'tableHeader', alignment: 'center'
              }],
              [{ text: '\nNo product is for return', colSpan: 3 }]
            ]
          },
          style: 'tablefont',
          marginTop: 5,
        };

        tblObject.push(tblProductDetails);
      }
    });

    return tblObject;
  }

  getWarningMessage() {
    return this.networkService.getRequest(this.configService.getWarningMessage());
  }

  // check survey message eligibility
  public checkSurveyMessageEligibilty() {
    return this.networkService.getRequest(this.configService.checkSurveyMessageEligibiltyData());
  }

  // save user survey preference
  public saveSurveyPreference(response) {
    return this.networkService.postRequest(this.configService.saveSurveyPreferenceData(), response);
  }

  public checkAutoApprove(accountNumber) {
    return this.networkService.getRequest(this.configService.soybeanCheckAutoApproveURL + '?accountNumber=' + accountNumber);
  }

  public submitForCreditAutoRequest(data) {
    return this.networkService.postRequest(this.configService.submitForCreditAutoApproval(), data);
  }


}
